'use strict';

import { Entity } from '../Entity';
import { Ind } from './Ind';

export class IndNote extends Entity {
  protected indNoteId;
  protected indNoteType;
  protected indNoteBody;
  protected indNoteInclude;
  protected indNoteDate;
  protected indNoteAuthor;
  protected importTab;
  protected rawDate;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indNoteId = data.indNoteId;
    this.indNoteType = data.indNoteType;
    this.indNoteBody = data.indNoteBody;
    this.indNoteInclude = data.indNoteInclude;
    this.indNoteAuthor = data.indNoteAuthor;
    this.importTab = data.importTab;
    this.rawDate = data.indNoteDate.date;

    if (data.indNoteDate) {
      const indNoteDate = data.indNoteDate.date.split(' ')[0].split('-');
      this.indNoteDate = indNoteDate[1] + '/' + indNoteDate[2] + '/' + indNoteDate[0];
    }
  }

  public getIndNoteId() {
    return this.indNoteId;
  }

  public getIndNoteType() {
    return this.indNoteType;
  }

  public setIndNoteType(indNoteType) {
    this.indNoteType = indNoteType;
    return this;
  }

  public getIndNoteBody() {
    return this.indNoteBody;
  }

  public setIndNoteBody(indNoteBody) {
    this.indNoteBody = indNoteBody;
    return this;
  }

  public getIndNoteInclude() {
    return this.indNoteInclude;
  }

  public setIndNoteInclude(indNoteInclude) {
    this.indNoteInclude = indNoteInclude;
    return this;
  }

  public getIndNoteDate() {
    return this.indNoteDate;
  }

  public setIndNoteDate(indNoteDate) {
    this.indNoteDate = indNoteDate;
    return this;
  }

  public getIndNoteAuthor() {
    return this.indNoteAuthor;
  }

  public setIndNoteAuthor(indNoteAuthor) {
    this.indNoteAuthor = indNoteAuthor;
    return this;
  }

  public getImportTab() {
    return this.importTab;
  }

  public getRawDate() {
    return this.rawDate;
  }

  public setRawDate(rawDate) {
    this.rawDate = rawDate;
    return this;
  }
}
